import React, { useState } from 'react';
import { IonIcon } from '@ionic/react';
import {
  arrowBackOutline,
  chevronDownOutline,
  informationCircleOutline,
  mailOutline,
} from 'ionicons/icons';
import './SettingsPage.css';

const HelpSupportPage = ({ onBack }) => {
  const [openFaq, setOpenFaq] = useState(null);

  const faqItems = [
    {
      question: 'How does image-to-SVG conversion work?',
      answer:
        'SvgTrace uses advanced algorithms to trace the contours and colors in your image and convert them into scalable vector format (SVG). Upload any JPG, PNG, or WebP image and the converter will produce a clean SVG output. Results vary based on image complexity and quality.',
      category: 'usage',
    },
    {
      question: 'What image formats can I upload?',
      answer:
        'SvgTrace supports the following formats:\n\n• JPEG / JPG\n• PNG\n• WebP\n\nFor best results, use high-contrast images with clear edges.',
      category: 'usage',
    },
    {
      question: 'How do I cancel my subscription?',
      answer:
        'You can cancel your subscription anytime:\n\n• Web (Stripe): Go to Settings > Subscription > Manage Subscription\n• iOS: Settings > Apple ID > Subscriptions > SvgTrace\n\nYour subscription will remain active until the end of your current billing period.',
      category: 'billing',
    },
    {
      question: 'How do I restore my purchase?',
      answer:
        "If you've purchased Pro on another device or after reinstalling:\n\n1. Sign in with the same account\n2. Your subscription should restore automatically\n3. On iOS, go to the paywall and tap 'Restore Purchases'\n\nIf you still have issues, contact support.",
      category: 'billing',
    },
    {
      question: 'What are AI features (Generate, Retrace, Modify)?',
      answer:
        'SvgTrace includes AI-powered tools:\n\n• Generate: Create SVG designs from text descriptions\n• Retrace: Enhance and re-trace existing images with AI for cleaner results\n• Modify: Edit and transform your designs with AI assistance\n\nAll AI features require a Pro subscription.',
      category: 'features',
    },
    {
      question: 'How do I delete my account?',
      answer:
        'To delete your account:\n\n1. Go to Settings > Account Settings\n2. Scroll to the "Danger Zone" section\n3. Click "Delete Account"\n4. Confirm deletion (this cannot be undone)\n\nThis will permanently delete all your data and saved files.',
      category: 'account',
    },
    {
      question: 'Can I use converted SVGs commercially?',
      answer:
        'Yes! You retain full ownership of SVGs created from your own images. You can use them for personal or commercial purposes. However, make sure you have the rights to the original images you upload.',
      category: 'usage',
    },
  ];

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="settings-page">
      <div className="sp-header">
        <button className="sp-back-btn" onClick={onBack}>
          <IonIcon icon={arrowBackOutline} />
        </button>
        <h2 className="sp-header-title">Help & Support</h2>
      </div>

      <div className="sp-scroll">
        {/* FAQ */}
        <div className="sp-section">
          <p className="sp-section-title">Frequently Asked Questions</p>
          {faqItems.map((item, i) => (
            <div key={i} className="sp-faq-item">
              <div className="sp-faq-q" onClick={() => toggleFaq(i)}>
                <span className="sp-faq-q-text">{item.question}</span>
                <span className="sp-faq-tag">{item.category}</span>
                <IonIcon
                  icon={chevronDownOutline}
                  className={`sp-faq-chevron ${openFaq === i ? 'sp-faq-chevron--open' : ''}`}
                />
              </div>
              {openFaq === i && (
                <div className="sp-faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>

        {/* App Information */}
        <div className="sp-section">
          <p className="sp-section-title">Contact & Info</p>
          <div className="sp-item sp-item--static">
            <div
              className="sp-item-icon"
              style={{ background: '#f1f5f9', color: '#64748b' }}
            >
              <IonIcon icon={informationCircleOutline} />
            </div>
            <div className="sp-item-body">
              <p className="sp-item-sub" style={{ margin: 0 }}>App Version</p>
              <p className="sp-item-title">1.0.0</p>
            </div>
          </div>
          <div className="sp-item sp-item--static">
            <div
              className="sp-item-icon"
              style={{ background: '#fdf4ff', color: '#a855f7' }}
            >
              <IonIcon icon={mailOutline} />
            </div>
            <div className="sp-item-body">
              <p className="sp-item-sub" style={{ margin: 0 }}>Support Email</p>
              <p className="sp-item-title">support@svgtrace.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpSupportPage;
